import React from 'react';
import { siteData } from '../data/mock';
import { Zap, ArrowRight, Sparkles } from 'lucide-react';

const CTASection = () => {
  return (
    <section id="cta" className="section section-alt">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-3xl p-10 sm:p-16 overflow-hidden">
            {/* Background decorations */}
            <div className="absolute top-0 right-0 w-80 h-80 bg-blue-600 rounded-full opacity-10 blur-3xl" />
            <div className="absolute bottom-0 left-0 w-60 h-60 bg-blue-400 rounded-full opacity-10 blur-3xl" />
            
            {/* Grid pattern */}
            <div
              className="absolute inset-0 opacity-[0.03]"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`,
              }}
            />

            <div className="relative z-10 text-center">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 mb-8">
                <Sparkles size={16} className="text-blue-400" />
                <span className="text-sm font-medium text-blue-200">Comece agora</span>
              </div>

              {/* Title */}
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                {siteData.cta.title}
              </h2>

              {/* Subtitle */}
              <p className="text-lg text-slate-300 mb-10 max-w-xl mx-auto">
                {siteData.cta.subtitle}
              </p>

              {/* CTA Button */}
              <a
                href={siteData.whatsapp.getLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all hover:scale-105 hover:shadow-xl hover:shadow-blue-600/25"
              >
                <Zap size={22} />
                {siteData.cta.button}
                <ArrowRight size={22} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
